<template>
  <div class="h-full overflow-hidden">
    <div class="icon-search__input ml-2px">
      <el-input
        placeholder="文件名称"
        v-model="keyword"
        size="small"
        clearable
        @keypress.enter.native="currentChange(1)"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="currentChange(1)"></i>
      </el-input>
    </div>
    <!-- 设备关联文档 -->
    <el-table
      :data="docTableData"
      v-loading="loading"
      :height="`calc(100% - 80px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column type="index" label="序号" min-width="20" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="文件名称"
        min-width="45"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="pointName"
        label="浏览次数"
        min-width="45"
        align="center"
      ></el-table-column>
      <el-table-column prop="value1" label="操作" min-width="30" align="center">
        <template slot-scope="scope">
          <span @click="viewFile(scope.row)" class="cursor-pointer">查看</span>
        </template>
      </el-table-column>
    </el-table>

    <file-view-dialog
      v-if="fileViewDialogVisible"
      @close="closeFileViewDialog"
      :fileSrc="viewFileSrc"
    ></file-view-dialog>
  </div>
</template>

<script>
import { DevicePointRelationApi } from '@wiz-api/tag-management'
import { EquipmentRfidApi } from '@wiz-api/huizhou2'
import { IotApi } from '@wiz-api/measuring-point-management'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import CardTitle from '@/components/cockpit/CardTitle'
import FileViewDialog from './components/FileViewDialog'

const equipmentRfidApi = new EquipmentRfidApi()
const devicePointRelationApi = new DevicePointRelationApi()
const iotApi = new IotApi()
const signalR = require('@microsoft/signalr')

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    FileViewDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      docTableData: [],
      keyword: '',
      fileViewDialogVisible: false,
      viewFileSrc: '',
      loading: false,
    }
  },
  watch: {
    transferProps: {
      handler() {
        this.getFileList()
      },
      deep: true,
    },
  },
  methods: {
    currentChange() {},
    openFileViewDialog(row) {
      this.viewFileSrc = row.src
      this.fileViewDialogVisible = true
    },
    closeFileViewDialog() {
      this.fileViewDialogVisible = false
    },
    // 获取文件列表
    async getFileList() {
      this.loading = true
      const [err, res] = await equipmentRfidApi.getEquipmentFiles({
        kkscode: this.getKksCode(this.transferProps.code),
      })
      if (!err) {
        this.docTableData = res
      }
      this.loading = false
    },
    // 查看文件
    viewFile(file) {
      const fileUrl = _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
      )?.deviceDocumentUrl
      if (fileUrl) {
        // window.open(`${fileUrl}${file.md5}`, '_blanck')
        this.viewFileSrc = `${fileUrl}${file.md5}`
        this.fileViewDialogVisible = true
      }
    },
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  created() {
    this.getFileList()
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}
</style>
